/* eslint-disable import/prefer-default-export */

import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var colour = variables.colour;

/* Shared styles for on-market listings */

export var mobileInterComponentGap = {
  name: "uewl2b",
  styles: "margin-bottom:20px;"
};
export var watchlistButton = /*#__PURE__*/css("position:absolute;top:20px;right:12px;filter:drop-shadow(0 0 5px ", colour.black, ");");
export var moreListingsContainer = /*#__PURE__*/css("border-top:1px solid ", colour.neutral200, ";margin-top:32px;padding-top:28px;margin-bottom:32px;.allhomes-listing-card{position:relative;}");
export var breadcrumbs = /*#__PURE__*/css("margin:10px 0 10px 8px;", media('>=tablet'), "{margin:20px 0 0;}", media('>=desktop'), "{margin:20px 0 18px;}");